import { useNavigate } from "react-router-dom";

import LoginOTPFrom from "../components/loginOTP/LoginOTPForm";

export const Login = () => {
  const navigate = useNavigate();

  return <LoginOTPFrom />;
};
